import axios from "axios";

export const SIGNED_DOCUMENTS_URL = "/api/signed-documents";
export const AUDIT_URL = "/api/audit-documents/signed";
const {REACT_APP_API_URL} = process.env;

export function downloadSignedDocument(signedDocumentId) {
    //https://stackoverflow.com/questions/60454048/how-does-axios-handle-blob-vs-arraybuffer-as-responsetype
    return axios.get(`${REACT_APP_API_URL}${SIGNED_DOCUMENTS_URL}/${signedDocumentId}/download`, {responseType: 'arraybuffer'});//responseType: 'blob'
}